module.exports = __webpack_public_path__ + "img/h5_switch.34444ad0.png";